<template>
  <b-container fluid>
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    <b-row>
      <b-col sm="6">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Agregar tarifa</h4>
            
          <div class="media text-muted pt-3">
            <b-form @submit.prevent="registrar()" v-if="show" style="width: 100%;">
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Tarifa" label-for="input-1">
                    <b-form-input v-model="form.Tarifa" type="text" required placeholder="Tarifa" />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label="Costo" label-for="input-1">
                    <b-form-input v-model="form.Costo" type="number" required placeholder="Costo" step="any"/>
                  </b-form-group>
                </b-col>
              </b-row> 
              <b-row v-if="form.Tarifa == '1'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Tarifa</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group> 
                </b-col> 
              </b-row>
              <b-row v-if="form.Tarifa == '1A'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group> 
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.Tarifa == '1F'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio alto" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano4" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.Tarifa == '1B'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group> 
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.Tarifa == '1E'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio alto" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano4" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="form.Tarifa == '1C'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio alto" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano4" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row> 
              <b-row v-if="form.Tarifa == '1D'" class="mt-3"> 
                <b-col sm="6">
                  <h4>Verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Verano1" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                    <b-form-input v-model="form.data.Verano2" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio alto" label-for="input-1">
                    <b-form-input v-model="form.data.Verano3" type="number" required  step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Verano4" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <h4>Fuera verano</h4>
                  <b-form-group label="Consumo básico" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno1" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo intermedio" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno2" type="number" required step="any"/>
                  </b-form-group>
                  <b-form-group label="Consumo excedente" label-for="input-1">
                    <b-form-input v-model="form.data.Invierno3" type="number" required step="any"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button type="submit" class="float-right boton_createch" variant="primary">
                <i class="far fa-save"></i> Guardar
              </b-button>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col sm="6">
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Tarifas</h4>
          <div class="media text-muted pt-3">
            <b-container fluid>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                stacked="md"
                :items="tarifas"
                :fields="fields"
                empty-text="No hay registros para mostrar"
              >
                <template v-slot:cell(actions)="row">
                  <b-button 
                    size="sm"
                    @click="info(row.item,$event.target)"
                    class="float-right btn_borrar"
                  >
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                  <b-button 
                    size="sm"
                    @click="edit(row.item,$event.target)"
                    class="float-right mr-1 btn_editar"
                  >
                    <i class="far fa-edit"></i>
                  </b-button>
                </template>
              </b-table>

              <!-- Info modal -->
              <b-modal
                :id="infoModal.id"
                :title="infoModal.title"
                @ok="eliminarTarifa(infoModal.eliminar)"
                centered
                ok-title="Eliminar"
                cancel-title="Cancelar"
              >
                <p
                  style="text-align:center; font-size:25px; font-weight:bold;"
                >¿Está seguro que desea eliminar?</p>
              </b-modal>
              <!-- Editar modal -->
              <b-modal :id="editModal.id" :title="editModal.title" hide-footer centered>
                <b-container>
                  <b-row>
                    <b-form @submit.prevent="actualizar()" v-if="show" style="width: 100%;">
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Tarifa" label-for="input-1">
                            <b-form-input
                              v-model="editModal.new.Tarifa"
                              type="text"
                              required
                              placeholder="Tarifa"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Costo" label-for="input-1">
                            <b-form-input
                              v-model="editModal.new.Costo"
                              type="number"
                              required
                              placeholder="Costo"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1F'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio alto" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano4" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1A'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group> 
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1'" class="mt-3">  
                        <b-col sm="6"> 
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group> 
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1B'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group> 
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1D'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group> 
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1E'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio alto" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano4" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="editModal.new.Tarifa == '1C'" class="mt-3">  
                        <b-col sm="6">
                          <h4>Verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano1" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio bajo" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano2" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio alto" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano3" type="number" required  step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Verano4" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <h4>Fuera verano</h4>
                          <b-form-group label="Consumo básico" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno1" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo intermedio" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno2" type="number" required step="any"/>
                          </b-form-group>
                          <b-form-group label="Consumo excedente" label-for="input-1">
                            <b-form-input v-model="editModal.new.data.Invierno3" type="number" required step="any"/>
                          </b-form-group>
                        </b-col>
                      </b-row>
                     
                      <hr />
                      <b-row>
                        <b-col>
                          <b-button
                            type="submit"
                            variant="primary"
                            size="sm"
                            class="float-right"
                          >Editar</b-button>
                          <b-button
                            variant="secondary"
                            size="sm"
                            class="float-right mr-1"
                            @click="ocultaModal(editModal.id)"
                          >Cancelar</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-row>
                </b-container>
              </b-modal>
            </b-container>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<style>
</style>
<script>
import axios from "axios";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      tarifas: [],
      fields: [
        { key: "name", sortable: true, label: "Tarifa" },
        { key: "cost", sortable: true, label: "Costo" },
        { key: "actions", label: "" }
      ],
      show: true,
      form: {
        Tarifa: "",
        Costo: "",
        data: {
          Verano1: "",
          Verano2: "",
          Verano3: "",
          Verano4: "",
          Invierno1: "",
          Invierno2: "",
          Invierno3: "",
        }
      },
      infoModal: {
        id: "info-modal",
        title: "",
        eliminar: ""
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: { _id: null, Tarifa: "", Costo: null, data:null }
      }
    };
  },
  components: {
    Loading
  },
  created() {
    this.listar();
  },
  methods: {
    eliminarTarifa(tarifa) {
      this.isLoading = true;
      axios
        .delete("tariff/" + tarifa)
        .then(respuesta => {
          this.listar();
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    },
    actualizar() {
      this.isLoading = true;
      axios
        .put("tariff/" + this.editModal.new._id, {
          name: this.editModal.new.Tarifa,
          cost: this.editModal.new.Costo,
          data: this.editModal.new.data
        })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe una tarifa con ese nombre.", "Tarifas");
          } else {
            this.listar();
            this.ocultaModal(this.editModal.id);
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    },
    info(item, button) {
      this.infoModal.title = `Eliminar tarifa: ${item.name}`;
      this.infoModal.eliminar = item._id;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    edit(item, button) {
      this.editModal.new.Tarifa = item.name;
      this.editModal.new._id = item._id;
      this.editModal.new.Costo = item.cost;
      this.editModal.new.data = item.data;
      this.editModal.title = `Editar tarifa: ${item.name}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    listar() {
      this.isLoading = true;
      axios
        .get("tariffs")
        .then(res => {
          if (res.data) {
            this.tarifas = res.data;
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast(
            "Ocurrió un error inesperado al consultar las tarifas existentes.",
            "Error"
          );
        });
    },
    registrar() {
      this.isLoading = true;
      axios
        .post("tariffs", { name: this.form.Tarifa, cost: this.form.Costo, data: this.form.data })
        .then(res => {
          if (res.status === 202) {
            this.makeToast("Ya existe una tarifa con ese nombre.", "Tarifas");
          } else {
            this.form.Tarifa = "";
            this.form.Costo = "";
            this.listar();
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast("Ocurrió un error inesperado.", "Error");
        });
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
    }
  }
};
</script> 